import { COLORS } from '@styles/colors'
import { FONTS } from '@styles/fonts'
import styled from 'styled-components'

export const Inspections = styled.div``

export const Inspection = styled.div`
  display: flex;
  align-items: center;
  border-bottom: 2px solid ${COLORS.nature.base};
  padding: 16px 0;

  &:first-child {
    padding-top: 0;
  }
`

export const InspectionInfo = styled.div`
  color: ${COLORS.secondary};
  font-family: ${FONTS.medium};
`

export const InspectionDate = styled.div`
  font-size: 18px;
  line-height: 26px;
  margin-bottom: 4px;
`

export const InspectionTime = styled.span`
  font-size: 14px;
  line-height: 20px;
`
